import type {
  MarketEvent,
  OptionInterval,
  StockInterval,
} from "./types";

export function eventRefreshesStockBars(
  event: MarketEvent,
  interval: StockInterval,
): boolean {
  return (
    event.type === "stock_bars" &&
    (event.interval === undefined ||
      event.interval === null ||
      event.interval === interval)
  );
}

export function eventRefreshesOptionBars(
  event: MarketEvent,
  selectedContract: string | null,
  interval: OptionInterval,
): boolean {
  return (
    event.type === "option_bars" &&
    selectedContract !== null &&
    event.contract === selectedContract &&
    (event.interval === undefined ||
      event.interval === null ||
      event.interval === interval)
  );
}
